import axios from 'axios'
import {API_URL} from '../constants';

const IMPORTEDFILES_API_URL = `${API_URL}/importFiles`;

class ImportedFileService {

    retrieveAllImportedFiles() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${IMPORTEDFILES_API_URL}/findAll`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    uploadFiles(files) {
        let formData = new FormData();
        for(var i=0; i<files.length; i++){
            formData.append('file', files[i]);
        }

        const token = sessionStorage.getItem('token');
        return axios.post(`${IMPORTEDFILES_API_URL}/upload`, formData,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    uploadCustomerFiles(files) {
        let formData = new FormData();
        for(var i=0; i<files.length; i++){
            formData.append('file', files[i]);
        }

        const token = sessionStorage.getItem('token');
        return axios.post(`${IMPORTEDFILES_API_URL}/uploadImages`, formData,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            if (response.data === 'Images are imported'){
                return 'OK';
            }
            return response.data;
        }).catch(error => {
            return error;
        });
    }    

    delete(id) {
        const token = sessionStorage.getItem('token');
        return axios.delete(`${IMPORTEDFILES_API_URL}/${id}`, 
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }    
}

export default new ImportedFileService()